module.exports = __webpack_public_path__ + "img/office_back.4021f535.jpg";